import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse, IBookingsSearchRequest, IBookingsSearchResponse, IPassBookingSearchRequest, IRetrieveBookingsSearchRequest } from "../../Orchestrator/Types/Index";


function buildBookingsSearchUrl(base: string, limit?: number, offset?: number): string {
    const params: string[] = [];
    if (typeof limit === "number") params.push(`limit=${limit}`);
    if (typeof offset === "number" && offset > 0) params.push(`offset=${offset}`);
    return params.length ? `${base}?${params.join('&')}` : base;
}

export async function postCustomBookingsSearch(
    searchRequest: IBookingsSearchRequest,
    limit?: number,
    offset?: number
): Promise<IApiResponse<IBookingsSearchResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = buildBookingsSearchUrl(ENDPOINTS.bookingsSearchCustom, limit, offset);

    return await apiRequest<IBookingsSearchResponse>(endpoint, 'POST', {
        body: JSON.stringify(searchRequest),
    });
}

export async function postCustomRetrieveBookingsSearch(
    searchRequest: IRetrieveBookingsSearchRequest,
    limit?: number
): Promise<IApiResponse<IBookingsSearchResponse>> {
    const ENDPOINTS = await getEndpoints();
    // Construct the endpoint for the custom bookings search
    const endpoint = `${ENDPOINTS.bookingsSearchCustom}${limit ? `?limit=${limit}` : ''}`;

    // Make the API request using the constructed endpoint and searchRequest
    return await apiRequest<IBookingsSearchResponse>(endpoint, 'POST', {
        body: JSON.stringify(searchRequest),
    });
}

export async function getPassBookings(
    searchRequest: IPassBookingSearchRequest,
    limit: number
): Promise<IApiResponse<IBookingsSearchResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.bookingsSearchCustom}${limit ? `?limit=${limit}` : ''}`;

    return await apiRequest<IBookingsSearchResponse>(endpoint, 'POST', {
        body: JSON.stringify(searchRequest),
    }, 'none', undefined, undefined, false);
}
